export default __webpack_public_path__ + "static/media/Cerin-Logo-shape-4-215x88.eb7da50e.png";